// Measures the wall-time delta between when a tax return processing task
// becomes ready (Redux task fetch succeeded) and when its associated PDF
// Document signals onLoadSuccess. The delta is shipped fire-and-forget to
// the backend so it can be reported to Elastic.

interface TimingContext {
    taskType: string;
    messageId?: string;
    correlationId?: string;
    FICode?: string;
    loanNumber?: string;
}

interface PendingEntry {
    startMs: number;
    context: TimingContext;
}

const pending = new Map<string, PendingEntry>();
const reported = new Set<string>();

export const recordTaskReady = (key: string | null | undefined, context: TimingContext): void => {
    if (!key) return;
    pending.set(key, { startMs: performance.now(), context });
    reported.delete(key);
};

export const recordPdfLoaded = (key: string | null | undefined): void => {
    if (!key) return;
    if (reported.has(key)) return;
    const entry = pending.get(key);
    if (!entry) return;
    reported.add(key);

    const taskToPdfMs = Math.round(performance.now() - entry.startMs);
    const payload = {
        key,
        taskToPdfMs,
        ...entry.context,
    };

    const endpoint = import.meta.env.VITE_ENDPOINT;
    if (!endpoint) return;

    try {
        fetch(`${endpoint}/returns/task-pdf-timing`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${sessionStorage.getItem("ACCESS_TOKEN")}`,
                "OCP-APIM-Subscription-Key": import.meta.env.VITE_OCP_APIM_SUB_KEY ?? "",
            },
            body: JSON.stringify(payload),
            keepalive: true,
        }).catch(() => {});
    } catch {
        // telemetry must never break the UI
    }
};
